import request from '@/plugin/axios';

//	新增合作方
export function CreatePartner (data) {
  return request({
    url: request.adornUrl(
      '/partner/create-partner'
    ),
    method: 'post',
    data
  });
}

//	获取合作方列表
export function GetPartner (params) {
  return request({
    url: request.adornUrl(
      '/partner/get-partner'
    ),
    method: 'get',
    params
  });
}

//  合作方批量删除接口
export function ManagePartner (data) {
  return request({
    url: request.adornUrl(
      '/partner/manage-partner'
    ),
    method: 'post',
    data
  });
}

//  获取主办方
export function orgList (params) {
  return request({
    url: request.adornUrl(
      '/sysOrg/orgList'
    ),
    method: 'get',
    params
  });
}
